module.exports = __webpack_public_path__ + "img/20190601135717294.ec2c6f2f.png";